import { axios } from '@/lib/axios'
import { Client } from '@twilio/conversations'
const baseUrl = process.env.API_BASE_URL

export const getTwilioInfo = async (userId: string) => {
  const res = await axios.post(`${baseUrl}/twilio-token`, {
    userId: userId,
  })
  return res
}

export const getTwilioClient = async (userId: string): Promise<Client> => {
  const twilioInfo = await getTwilioInfo(userId)
  const twilioClient = new Client(twilioInfo.data.jwt)
  const refreshToken = async () => {
    const newTwilioInfo = await getTwilioInfo(userId)
    twilioClient.updateToken(newTwilioInfo.data.jwt)
  }

  twilioClient.on('tokenAboutToExpire', refreshToken)
  twilioClient.on('tokenExpired', refreshToken)

  return twilioClient
}
